import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from 'src/environments/environment';
import {
	StoreRouterConnectingModule,
	FullRouterStateSerializer,
} from '@ngrx/router-store';
import { RailroadDetailStateModule } from 'src/admin-app/railroads/railroad-detail/+state/railroad-detail-state.module';
import { CustomerDetailStateModule } from 'src/admin-app/customers/customer-detail/+state/customer-detail-state.module';
import * as fromApp from './app.reducer';
import * as fromRouter from '@ngrx/router-store';
import { PersonnelDetailStateModule } from 'src/admin-app/personnel/personnel-detail/+state/personnel-detail-state.module';
import { FieldTeamDetailStateModule } from 'src/admin-app/field-teams/field-team-detail/+state/field-team-detail-state.module';
import { QuoteDetailStateModule } from 'src/admin-app/quotes/quote-detail/+state/quote-detail-state.module';
import { JobDetailStateModule } from 'src/admin-app/jobs/job-detail/+state/job-detail-state.module';
import { AdminUserStateModule } from 'src/admin-app/users/admin-users/+state/admin-user-state.module';
import { CustomerUsersStateModule } from 'src/admin-app/users/customer-users/+state/customer-users-state.module';
import { AppEffects } from './app.effects';

@NgModule({
	declarations: [],
	imports: [
		StoreModule.forRoot(fromApp.reducer, {
			runtimeChecks: {
				strictStateImmutability: false,
				strictActionImmutability: false,
				strictStateSerializability: false,
				strictActionSerializability: false,
				strictActionWithinNgZone: false,
			},
			metaReducers: !environment.production ? [] : [],
		}),
		StoreModule.forFeature('router', fromRouter.routerReducer),
		!environment.production ? StoreDevtoolsModule.instrument() : [],
		EffectsModule.forRoot([AppEffects]),
		StoreRouterConnectingModule.forRoot({
			serializer: FullRouterStateSerializer,
		}),
		RailroadDetailStateModule,
		CustomerDetailStateModule,
		PersonnelDetailStateModule,
		FieldTeamDetailStateModule,
		QuoteDetailStateModule,
		JobDetailStateModule,
		AdminUserStateModule,
		CustomerUsersStateModule,
	],
})
export class AppStateModule {}
